/**
 * ColorValue type for widget color properties
 *
 * Colors can be stored in two ways:
 * - theme: References a theme color by name (e.g., 'primary', 'secondary')
 * - custom: A custom hex color value (e.g., '#ff0000')
 */
export type ColorValue =
  | { type: "theme"; value: string }
  | { type: "custom"; value: string };

/**
 * Type guard to check if a value is a ColorValue object
 */
export const isColorValue = (val: unknown): val is ColorValue => {
  return (
    typeof val === "object" &&
    val !== null &&
    "type" in val &&
    "value" in val &&
    ((val as ColorValue).type === "theme" ||
      (val as ColorValue).type === "custom")
  );
};

/**
 * Helper to create a theme color reference
 */
export const themeColor = (name: string): ColorValue => ({
  type: "theme",
  value: name,
});

/**
 * Helper to create a custom color value
 */
export const customColor = (hex: string): ColorValue => ({
  type: "custom",
  value: hex,
});
